// extracted by mini-css-extract-plugin
module.exports = {"author":"L_bW","wrapper":"L_bX","fontImage":"L_bY","container":"L_x"};